module.exports = __webpack_public_path__ + "static/img/TFHJ.b8290ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/TFHJ.png
// module id = zZn6
// module chunks = 34